/**
 * Created by tofael on 3/23/17.
 */
import React from 'react';

const NotFoundPage = () => {
  return (
      <div>
        <div>
          404 Page Not Found
        </div>
      </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/screens/shared/not-found.js